import React, { type FC } from 'react';

export const RebrandedTicketSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M7.97135 10.0026C7.97135 10.5204 7.55162 10.9401 7.03385 10.9401C6.51609 10.9401 6.09635 10.5204 6.09635 10.0026C6.09635 9.48484 6.51609 9.0651 7.03385 9.0651C7.55162 9.0651 7.97135 9.48484 7.97135 10.0026Z"
                fill="#161719"
            />
            <path
                d="M10.0026 10.9401C10.5204 10.9401 10.9401 10.5204 10.9401 10.0026C10.9401 9.48484 10.5204 9.0651 10.0026 9.0651C9.48484 9.0651 9.0651 9.48484 9.0651 10.0026C9.0651 10.5204 9.48484 10.9401 10.0026 10.9401Z"
                fill="#161719"
            />
            <path
                d="M12.9714 10.9401C13.4891 10.9401 13.9089 10.5204 13.9089 10.0026C13.9089 9.48484 13.4891 9.0651 12.9714 9.0651C12.4536 9.0651 12.0339 9.48484 12.0339 10.0026C12.0339 10.5204 12.4536 10.9401 12.9714 10.9401Z"
                fill="#161719"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8359 0.835938V2.011C10.8359 2.51262 10.4628 2.91927 10.0026 2.91927C9.54237 2.91927 9.16927 2.51262 9.16927 2.011V0.835938H3.33594V19.1693H9.16927V17.9942C9.16927 17.4926 9.54237 17.0859 10.0026 17.0859C10.4628 17.0859 10.8359 17.4926 10.8359 17.9942V19.1693H16.6693V0.835938H10.8359ZM7.55033 2.5026C7.76442 3.60494 8.68371 4.58594 10.0026 4.58594C11.3215 4.58594 12.2408 3.60494 12.4549 2.5026H15.0026V17.5026H12.4549C12.2408 16.4003 11.3215 15.4193 10.0026 15.4193C8.68371 15.4193 7.76442 16.4003 7.55033 17.5026H5.0026V2.5026H7.55033Z"
                fill="#161719"
            />
        </svg>
    );
};
